import { useMutation } from 'react-query';

import { CancelableRequestOptions, getClient } from '@/lib/restClient';
import {
  MosPosMenuMasterService,
  MosPosValidateResponse,
} from '@/services/MosPosMenuMaster';

export type ValidateImportParams = {
  masterFile: File;
  relationFile: File;
  /** 新しい選択で上書きされたときに送信中のリクエストを止めるための受け口です。 */
  cancelable?: CancelableRequestOptions;
};

/** 2ファイルを検証します。business validation の Error は例外ではなく戻り値で返ります。 */
export const useValidateMosPosMenuImport = () => {
  const { mutateAsync, isLoading, error, reset } = useMutation<
    MosPosValidateResponse,
    Error,
    ValidateImportParams
  >(async ({ masterFile, relationFile, cancelable }) => {
    const service = new MosPosMenuMasterService(getClient());
    return await service.validateImport(masterFile, relationFile, cancelable);
  });

  return { validateImport: mutateAsync, isValidating: isLoading, error, reset };
};
